import { Registry } from '.';

export default ({ get, post, put, destroy }: Registry) => {
  return {
    standalone: {
      getAll: <T = any>(entity: string) => get<T[]>(`/api/v1/stand_alone/models/${entity}/`),
      get: <T = any>(entity: string, id: any) => get<T>(`/api/v1/stand_alone/models/${entity}/${id}/`),
      create: <T = any>(entity: string, payload: Partial<T>) => post<T>(`/api/v1/stand_alone/models/${entity}/`, payload),
      update: <T = any>(entity: string, id: any, payload: T) => put<T>(`/api/v1/stand_alone/models/${entity}/${id}/`, payload),
    }
  };
};
